var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWalk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#333",
  clipPath: "url(#walk_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m5.84 10.72 1.296 1.296-1.12 3.024a.843.843 0 0 1-1.072.496.836.836 0 0 1-.496-1.072z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.424 7.408.768-1.472c.208-.384.512-.704.88-.928 1.776-1.056 2-1.04 2.224-1.024l1.2.08c.368.016.624.112 1.856 1.92a.31.31 0 0 0 .208.128l1.472.224c.4.064.672.432.608.832a.725.725 0 0 1-.832.608l-1.472-.224a1.77 1.77 0 0 1-1.184-.736c-.064-.096-.112-.176-.176-.256l-.944 2.992 1.312 1.312c.192.192.352.448.448.704l1.008 2.944a.82.82 0 0 1-.512 1.056.8.8 0 0 1-.272.048.86.86 0 0 1-.8-.56l-1.008-2.944c-.016-.032-.032-.048-.048-.08L5.824 9.68a1.35 1.35 0 0 1-.368-1.248l.512-2.272c-.048.032-.096.064-.16.096a.9.9 0 0 0-.336.352L4.704 8.08a.73.73 0 0 1-.64.384.9.9 0 0 1-.336-.08.735.735 0 0 1-.304-.976M8.317.401a1.616 1.616 0 1 1-.35 3.213 1.616 1.616 0 0 1 .35-3.213"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "walk_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export { SvgWalk as ReactComponent };